import { Injectable, OnInit, Injector } from '@angular/core';
import { ParserService } from '../ws/ws.service';
import { environment } from '../../../../environments/environment';
import { IPermissionsParser } from './permissions-parser';
import { IPermissionsManager } from './permissions-manager';
import { WsService2 } from '../ws/ws.service';
@Injectable()
export class PermissionsParserService extends ParserService implements IPermissionsParser {
    constructor(ws: WsService2) {
        super(ws);
    }

    setManager(r: IPermissionsManager) {
        this.manager = r;
    }
    manager: IPermissionsManager
    parseMessage(m) {
        switch (m.cmd) {
            case "useTools": this.manager.useTools(m.use); break;
        }
    }
    sendUseTools(to, use){
        this.send("useTools", {who: to, use: use});
    }

}



// WEBPACK FOOTER //
// /app/src/app/wb/services/permissions/permissions-parser.service.ts